export default "__VITE_ASSET__C97gi0FD__"